import { TeamRoster } from '@ordo/ui/team-roster'
import { Page } from 'compositions/Page'
import { useTeamRoster } from 'hooks/api'

/**
 * Admin → Team. The shared HQ staff roster (`@ordo/ui/team-roster`), read-only:
 * HQ is the single place access is edited, so every row links out to HQ.
 * Boombox's contacts (the people it messages) are managed under People.
 */
export function AdminTeam() {
  const { data, loading, error } = useTeamRoster()

  return (
    <Page>
      <div className="mb-4">
        <h1 className="text-xl font-semibold">Team</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Ordo HQ staff and their Boombox access. Access is managed in HQ.
        </p>
      </div>
      <TeamRoster
        members={data?.members}
        isLoading={loading}
        error={error ? error.message || 'Failed to load the team' : null}
        appName="Boombox"
      />
    </Page>
  )
}
